export default __webpack_public_path__ + "static/avatar-kayi-common-0-detail-cc4fa5ddec11689973a74a469090581d.png";